import React from 'react';
const InventoryAlertsTab = () => {
  return (
    <div>
      <div className="control_blk_containers filter_blk mb_15">
        <h3 className="font_16 fw-semi text_black mb_15">Parts Priced Below Core Value</h3>
        <table className="w-100 table">
          <thead>
            <tr>
              <th>Region</th>
              <th>Interchange Number</th>
              <th>Stock Number</th>
              <th>Model Name</th>
              <th>Model Year</th>
              <th>Part Price</th>
              <th>Highest Core Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adequately Stocked</td>
              <td>Adequately Stocked</td>
              <td>Adequately Stocked</td>
              <td>Adequately Stocked</td>
              <td>Adequately Stocked</td>
              <td>Adequately Stocked</td>
              <td>Adequately Stocked</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="control_blk_containers filter_blk mb_15">
        <h3 className="font_16 fw-semi text_black mb_15">Parts with Negative Condition Flags</h3>
        <div className="table-responsive">
          <table className="w-100 table table_color">
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Stock Number</th>
                <th>Interchange Number</th>
                <th>Model Name</th>
                <th>Model Year</th>
                <th>Milage</th>
                <th>Part Price</th>
                <th>Comments</th>
                <th>Flagged Keywords</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>CA12622</td>
                <td>10619</td>
                <td>FORD F150 PICKUP</td>
                <td>2024</td>
                <td>13</td>
                <td>4100</td>
                <td>TIMING COVER DAMAGE HAS HOLE A 4WD 5.00L</td>
                <td>damage, hole</td>
              </tr>
              <tr>
                <td>2</td>
                <td>CA12622</td>
                <td>10619</td>
                <td>FORD F150 PICKUP</td>
                <td>2024</td>
                <td>13</td>
                <td>4100</td>
                <td>DAMAGED WATER PUMP SEE IMAGES CUSTOMER REPLACE PRICE ACCORDINGLY 4WD 2.50L</td>
                <td>damage, hole</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default InventoryAlertsTab; 